import ClientPassengerInterface from '../../interfaces/client/Passenger'

import getUniquePassengerIdsFromFormValues from './getUniquePassengerIdsFromFormValues'
import buildPassengerFromFormValues from './buildPassengerFromFormValues'

export default (formValues: any): ClientPassengerInterface[] => {
  const uniquePassengerIds = getUniquePassengerIdsFromFormValues(formValues)

  return uniquePassengerIds.reduce(
    (allPassengers: ClientPassengerInterface[], currentPassengerId: string) => {
      const passenger = buildPassengerFromFormValues(
        currentPassengerId,
        formValues
      )

      if (!passenger) return allPassengers

      return [...allPassengers, passenger]
    },
    []
  )
}
